import { render, staticRenderFns } from "./NewPlusPromoRoadblock.vue?vue&type=template&id=18ae46ff&scoped=true&"
import script from "./NewPlusPromoRoadblock.vue?vue&type=script&lang=js&"
export * from "./NewPlusPromoRoadblock.vue?vue&type=script&lang=js&"
import style0 from "./NewPlusPromoRoadblock.vue?vue&type=style&index=0&id=18ae46ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ae46ff",
  null
  
)

export default component.exports